module.exports = __webpack_public_path__ + "img/cart-icon-stroke--white.09c4d66.svg";